/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Announcement_ActionInputs */

const en_google_drive_announcement_action = /** @type {(inputs: Google_Drive_Announcement_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import from Drive`)
};

const es_google_drive_announcement_action = /** @type {(inputs: Google_Drive_Announcement_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar desde Drive`)
};

/**
* | output |
* | --- |
* | "Import from Drive" |
*
* @param {Google_Drive_Announcement_ActionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_announcement_action = /** @type {((inputs?: Google_Drive_Announcement_ActionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Announcement_ActionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_announcement_action(inputs)
	return en_google_drive_announcement_action(inputs)
});